export default __webpack_public_path__ + "static/media/illust@3x.a8e74f78.png";